export default __webpack_public_path__ + "static/media/Standard23.43a77649.png";